module.exports = __webpack_public_path__ + "img/pcards_new.420ec58.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pcards_new.jpg
// module id = ./assets/img/pcards_new.jpg
// module chunks = 9